import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import { DialogContentText, Grid } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import './styles.css';
import { CommonConfig } from '../../../config/common-config';
import SuccessPopUp from '../../../components/loaderpopup/success';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    fileName: {
        textAlign: 'center'
    },
    toolTipFont: {
        fontFamily: 'Rubik !important',
        fontSize: '12px',
    },
    otherstoolTipFont: {
        fontFamily: 'Rubik !important',
        fontSize: '12px',
        // width: '25%',
        // marginRight: '12px'
    },
    noteMsg: {
        color: '#4c4c4c',
        marginRight: '68px',
        fontSize: '11px',
    },
    downloadImg: {
        width: '25px',
        height: '26px',
        position: 'relative',
        top: '6px',
        left: '6px',
    },
    btnView: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0px !important',
        // width: '45%'
    },
    pointerEvents: {
        pointerEvents: 'none !important',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
        background: 'rgba(0, 0, 0, 0.12) !important',
        color: 'rgba(0, 0, 0, 0.12) !important',
    },
    pointer: {
        pointerEvents: 'none !important'
    },
    finaldoctitle: {
        color: '#4c4c4d',
        fontSize: '18px !important',
        fontWeight: '600 !important',
        textAlign: 'center',
        fontFamily: 'Rubik'
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    remarks: {
        fontSize: '1rem',
        borderBottom: '1px solid #ccc',
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    }
}));

export default function DeleteCoreEmp() {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch({});
    // const bull = <span className={classes.bullet}>•</span>;
    const [state, setState] = React.useState({
        checkedA: true,
    });
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [URLValue, setURLValue] = useState();
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);

    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [attachedFilename, setAttachedFilename] = useState('');
    const [uploadDisable, setUploadDisable] = useState(true);
    const [coreTeamFilename, setCoreTeamFilename] = useState('');
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const coreFilename = [];
    const [downloadFile, setDownloadFile] = useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const [deleteEmp, setDeleteEmp] = useState(false);
    const [itecEmpId, setItecEmpId] = useState();
    const [tennantName, setTennantName] = useState();


    useEffect(() => {
        console.log('history.location.state', history.location.state)
        if (history.location && history.location.state && history.location.state.itecEmpId) {
            setItecEmpId(history.location.state.itecEmpId)
        }
        if (history.location && history.location.state && history.location.state.itecEmpId) {
            setTennantName(history.location.state.tennantName)
        }
    }, [bearerToken]);

    const navigateBack = () => {
        history.push({
            pathname: '/menu/coreemployeesitec',
            state: { domainname: tennantName },
        });

    }

    const handleDelete = () => {
        axios
            .delete(`${CommonConfig.dev.baseUrl}/api/auth/intClient-employee/${tennantName}/${itecEmpId}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                const { status } = response;
                if (status === 200) {
                    // loader need to implemented
                    setDeleteEmp(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        setSuccessPop(false);
                        history.push({
                            pathname: '/menu/CoreView',
                        });
                    }, 3000);
                }
            })
            .catch((e) => {
                // error msg need to be implemented
            });
    }

    const handleClose = () => {
        setSuccessPop(false);
    };

    return (
        <div>
            {successpop ? (
                <SuccessPopUp
                    open={successpop}
                    showSuccess={successpop}
                    handleClose={handleClose}
                    title="Core employee deleted successfully"
                />
            ) : null}
            {/* <div className="stage-indicator">
                <ul>
                    <li>L1 Checklist</li>
                    <li>L1 CRC Confirmed</li>
                    <li>Detailed Analysis</li>
                    <li>Draft Statements</li>
                    <li className="active">Tax Payment and Filing</li>
                </ul>
            </div> */}
            {/* {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} handleClose={handleClose} title="Approved the Tax Payment" />) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />) : null} */}

            <Formik
            // initialValues={initialValues}
            // onSubmit={(values) => handleSubmit(values)}
            // enableReinitialize
            >
                {(formik) => {
                    return (
                        <form className="itecform">
                            <Card className={classes.root}>
                                <CardContent>
                                    <form className="itecform" onSubmit={formik.handleSubmit}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={12}>
                                                <Typography className="final-doc-title">All the task of this particular employee is assigned.</Typography>
                                                <Typography className={classes.finaldoctitle}>Kindly press delete button to delete the employee.</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl fullWidth className="mt50 mb50">
                                                    <Button
                                                        variant="outlined"
                                                        color="primary"
                                                        size="small"
                                                        className={classes.button}
                                                        onClick={() => setDeleteEmp(true)}
                                                        onBlur={formik.handleBlur}
                                                    >
                                                        Delete Employee
                                                    </Button>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>

                            <div className="footer-button">
                                <ul>
                                    <li>
                                        <Button
                                            color="primary"
                                            className="buttonnext txt-cap"
                                            onClick={() => {
                                                navigateBack();
                                            }}
                                        >
                                            Back
                                        </Button>
                                    </li>
                                </ul>

                            </div>
                        </form>
                    );
                }}
            </Formik>

            <Dialog
                open={deleteEmp}
                onClose={() => setDeleteEmp(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ fontFamily: 'Rubik' }}
            >
                <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                    Please confirm
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                        Are you sure you want to delete this record? If yes, press Ok or press Cancel to go back.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className={classes.popFoot}>

                    <Button onClick={() => setDeleteEmp(false)} variant="outlined" color="primary" size="small" className={classes.btnBluepop} autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={() => handleDelete()} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                        {/* Ok */}
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
            {/* {
                showBtnLoader ? (
                    <LoaderPopUp
                        showLoader={showBtnLoader}
                        handleClose={handleClose}
                        title="Please wait while approving Tax Payment Document"
                    />
                ) : null
            } */}
        </div>
    );
}
